import React from 'react';
import './Loading.css';

const Loading = () => {
    return (
        <div className="loading-screen">
            <div className="dots">
                <span></span>
                <span></span>
                <span></span>
            </div>
        </div>
    );
};

export default Loading;
